<script lang="ts">
  import { entryTitle, type thresholdId } from './FilterRow.utils';

  interface Props {
    id: thresholdId;
    /** @bind */
    value?: number;
  }

  let { id, value = $bindable(10) }: Props = $props();
</script>

<div class="border-table-border bg-base-200 flex flex-col items-start rounded-xl border p-2 pl-4">
  <div class="inline-flex items-center">
    <div>{entryTitle(id)}&nbsp;</div>
    <input
      class="bg-base-200 border-base-300 w-16 rounded border p-1 text-center"
      min="0"
      max="40"
      step="0.1"
      type="number"
      bind:value
    />
  </div>
  <input class="input-range h-1" type="range" min="0" max="100" step="0.1" bind:value />
</div>

<style>
  .input-range {
    appearance: auto;
    -webkit-appearance: none;

    &::-webkit-slider-runnable-track {
      height: 5px;
      background: #fff;
      border: none;
      border-radius: 3px;
    }

    &::-webkit-slider-thumb {
      -webkit-appearance: none;
      border: none;
      height: 16px;
      width: 16px;
      border-radius: 50%;
      background: goldenrod;
      margin-top: -4px;
    }

    &:focus {
      outline: none;
    }

    &:focus::-webkit-slider-runnable-track {
      background: rgb(var(--color-primary-900));
    }
  }
</style>
